import { Styled } from "components/Styled"

export const ContentWrapper = () => {
    return (
        <Styled.PBody1>
            Кожен раз, коли ви заправляєте свій автомобіль на нашій
            автозаправній станції, ви отримуєте бонусні бали, які накопичуються
            на вашому обліковому записі. Ці бали можна обміняти на різноманітні
            переваги, такі як безкоштовні заправки, знижки на товари або послуги
            нашого партнерського мережі.
            <br />
            <br />
            Наша бонусна система - це наш спосіб подякувати вам за вашу вірність
            та постійну підтримку. Ми цінуємо кожне заправлення, яке ви робите
            на нашій станції, і хочемо нагородити вас за це.
            <br />
            <br />
            Приєднуйтеся до нашої бонусної програми вже сьогодні та отримуйте
            бонуси з кожного заправленого літра. Ми вдячні вам за обрання нашої
            автозаправної станції і готові дарувати вам ще більше задоволення та
            переваги в кожній вашій поїздці.
        </Styled.PBody1>
    )
}